// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2FhSt","content":"styles_content__2f3wy","selectAll":"styles_selectAll__Lv_Fa"};